<template>
    <div class="intro">
        <h1 v-html="page.title"></h1>
        <ul class="list">
            <li class="item" v-for="item in page.plus">{{item.caption}}</li>
        </ul>
        <p class="text" v-html="page.baseline">
        </p>
        <Cta
            :type="'button'"
            :direction="'down'"
            :colors="{ default: { color: '#ff2b2a', background: '#FFF' } }"
            class="link"
            @click.native="openLocations()"
        >
            {{page.ourlocations}}
        </Cta>
    </div>
</template>
<script>
import Cta from '@/components/Cta'
export default {
    components: {
        Cta
    },
    props: {
        page: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    methods: {
        openLocations() {
            this.$emit('locations')
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
.intro
    height: 100vh
    width: auto
    padding: 1px 0
    margin-left: (100% * 422 / 1920)
    position: relative
    @include media-breakpoint-down($lg)
        margin-left: (100% * 211 / 1920)
    @include media-breakpoint-down($md)
        margin-left: 9.6%
        margin-right: 9.6%
h1
    font-size: 150px
    color: #ff2b2a
    margin: 27.7777777778vh 0 0
    line-height: 0.89375
    font-weight: 500
    letter-spacing: -0.03125em
    position: relative
    // width: (100% * 1080 / 1920)
    &:after
        content: ''
        display: block
        width: 54vh
        height: 54vh
        border-radius: 50%
        border: 2px solid rgba(#ff2b2a, .1)
        position: absolute
        top: -.5vh
        left: -17.5vh
    @include media-breakpoint-down($xl)
        font-size: 112px
    @media (max-height: 880px)
        font-size: 112px
    @include media-breakpoint-down($lg)
        font-size: 86px
    @include media-breakpoint-down($md)
        margin-top: 180px
        font-size: 50px
    @include media-breakpoint-down($sm)
        margin-top: 100px
        font-size: 36px
.list
    display: inline-block
    margin-top: 1%
    width: (100% * 750 / 1920)
    @include media-breakpoint-down($md)
        width: 100%
    // @include media-breakpoint-down($sm)
    //     display: none
    .item
        position: relative
        font-size: 25px
        color: #646873
        margin-top: 4vh
        font-weight: 500
        padding-left: 3em
        @include media-breakpoint-down($xl)
            font-size: 20px
        @media (max-height: 880px)
            font-size: 20px
        @include media-breakpoint-down($lg)
            font-size: 17px
        &:before, &:after
            content: ""
            position: absolute
            display: block
            top: 50%
            left: 0
            width: 19px
            height: 2px
            background: #ff2b2a
        &:after
            transform: rotate(90deg)
.text
    margin-top: 2.5em
    display: inline-block
    width: 100%
    max-width: 380px
    font-weight: 500
    font-size: 20px
    color: #636776
    line-height: 1.647058824
    vertical-align: top
    @include media-breakpoint-down($xl)
        font-size: 17px
    @media (max-height: 880px)
        font-size: 17px
    @include media-breakpoint-down($sm)
        font-size: 14px
.link
    position: absolute
    bottom: 0
    margin-bottom: 5.7407407407vh
    left: 0
    @include media-breakpoint-down($sm)
        position: relative
        bottom: initial
        left: initial
        margin-bottom: 0
        margin-top: 6.25%
</style>
